<div class="ifs-grid">
  <label>{{ i18n.i18nLng()['CARDHOLDER'] }}<div id="ifs-holder" class="ifs-field"></div></label>
  <label>{{ i18n.i18nLng()['CARDNUMBER'] }}<div id="ifs-pan" class="ifs-field"></div></label>
  <label>{{ i18n.i18nLng()['VALIDITYDATE'] }}<div id="ifs-expiry" class="ifs-field"></div></label>
  <label>{{ i18n.i18nLng()['CARDSECURITYCODE'] }}<div id="ifs-cvv" class="ifs-field"></div></label>
</div>
